import React from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import {replace} from "react-router-redux";

import UserRoles from "../../../../../common/src/enums/UserRoles";
import {ROUTE_CLUB, ROUTE_CLUBS, ROUTE_MEMBER, ROUTE_MEMBERS} from '../../../constants/routeconstants';
import * as AdminActions from "../../../actions/admin";

import {NotificationManager} from "react-notifications";

import MemberGeneral from "./subPages/MemberGeneral";
import MemberMarkings from "./subPages/MemberMarkings";
import {defaultState as generalProps} from "./subPages/MemberGeneral";
import {defaultState as markingProps} from "./subPages/MemberMarkings";

import {hasCommonProps} from "../../../utils/Util";

class MemberPage extends React.Component {

    static getId() {
        return ROUTE_MEMBER;
    }

    static getAllowedRoles() {
        return [UserRoles.CLUB_ADMIN, UserRoles.MAIN_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.loadMember(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params.clubNo !== this.props.params.clubNo || nextProps.params.memberNo !== this.props.params.memberNo) this.loadMember(nextProps);
    }

    loadMember = newestProps => {
        if (newestProps.params.clubNo !== 'undefined' && newestProps.params.clubNo !== 'new') {
            const club = newestProps.admin.clubs ? newestProps.admin.clubs.get(newestProps.params.clubNo) || null : null;
            if (club === null || typeof (club.isFullLoaded) === 'undefined') newestProps.dispatch(AdminActions.getClub(newestProps.params.clubNo));
        }
        if (!newestProps.params.memberNo.toLowerCase().startsWith('new')) newestProps.dispatch(AdminActions.getMember(newestProps.params.memberNo));
    };

    render() {
        const clubNo = this.props.params.clubNo;
        const club = clubNo.toLowerCase() === 'undefined' || clubNo.toLowerCase() === 'new' || !this.props.admin.clubs ? null : this.props.admin.clubs.get(clubNo) || null;
        const memberNo = this.props.params.memberNo.toLowerCase().startsWith('new') ? this.props.params.memberNo.substring(3) : this.props.params.memberNo;
        let member = memberNo === '' ? null : (this.props.params.memberNo.toLowerCase().startsWith('new') ? (club === null ? null : club.UpdateRequests.find(req => req.type === 'member' && req.newKey === memberNo) || null) : (!this.props.admin.members ? null : this.props.admin.members.get(memberNo) || null));
        if (this.props.params.memberNo.toLowerCase().startsWith('new') && member !== null) member = JSON.parse(member.updates);
        if (memberNo !== '' && (member === null || (!this.props.params.memberNo.toLowerCase().startsWith('new') && typeof(member.isFullLoaded) === 'undefined'))) return null;

        let subPage = null;
        switch (this.props.params.subpage) {
            case 'general':
                subPage = <MemberGeneral club={club} member={member} isNew={this.props.params.memberNo.toLowerCase().startsWith('new')} editMode={this.props.params.mode === 'edit' || this.props.params.mode === 'create'} ref={instance => {this.subForm = instance;}} newMemberNumber={memberNo}/>
                break;
            case 'markings':
                subPage = <MemberMarkings club={club} member={member} isNew={this.props.params.memberNo.toLowerCase().startsWith('new')} editMode={this.props.params.mode === 'edit' || this.props.params.mode === 'create'} ref={instance => {this.subForm = instance;}} newMemberNumber={memberNo}/>
                break;
        }

        const updateReq = this.props.params.memberNo.toLowerCase().startsWith('new') || club === null ? null : club.UpdateRequests.find(req => req.type === 'member' && req.key === memberNo) || null;
        const updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);

        return (<div>
            <div className="sub-page-title">
                <h2>{(memberNo === '' ? 'Nyt medlem' : 'Medlem ' + memberNo + ' - ' + (member === null || typeof(member.Fornavn) === 'undefined' ? '' : member.Fornavn) + ' ' + (typeof(member.Efternavn) === 'undefined' ? '' : member.Efternavn)) + (club === null ? '' : ' (Forening ' + clubNo + ', ' + club.Navn + ')')}</h2>
            </div>
            <div className="sub-page-content">
                <div className="tab-list">
                    <Link className={(this.props.params.subpage === 'general' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled')) + (hasCommonProps(updates, generalProps) ? ' has-updates' : '')} to={this.props.params.mode === 'view' ? ROUTE_MEMBER.replace(":clubNo", clubNo).replace(":memberNo", this.props.params.memberNo).replace(":subpage", "general").replace(":mode", "view") : ''}>
                        <span className="tab-text">Generelt</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'markings' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled')) + (hasCommonProps(updates, markingProps) ? ' has-updates' : '')} to={this.props.params.mode === 'view' ? ROUTE_MEMBER.replace(":clubNo", clubNo).replace(":memberNo", this.props.params.memberNo).replace(":subpage", "markings").replace(":mode", "view") : ''}>
                        <span className="tab-text">Markeringer</span>
                    </Link>
                </div>
                <div className="tab-page">
                    {subPage}
                </div>
            </div>
            <div className="sub-page-actions">
                {this.props.params.mode === 'view' ? [
                    <span className="left-buttons" key="left">
                        {this.props.params.subpage === 'general' || this.props.params.subpage === 'markings' ? <button className="btn-primary" title="Rediger medlem" disabled={this.props.auth.currentRole !== UserRoles.MAIN_ADMIN.id && (this.props.auth.currentRole !== UserRoles.CLUB_ADMIN.id || this.props.auth.currentEntity !== clubNo)} onClick = {() => {
                            this.props.dispatch(replace(ROUTE_MEMBER.replace(":clubNo", clubNo).replace(':memberNo', this.props.params.memberNo).replace(':subpage', this.props.params.subpage).replace(':mode', 'edit')));
                        }}>Rediger</button> : null}
                    </span>,
                    <span className="right-buttons" key="right">
                        {<Link className="btn-primary" to={ROUTE_CLUB.replace(':clubNo', clubNo).replace(":subpage", "members").replace(":mode", "view")} title={"Vis forening " + clubNo}>
                            Forening {clubNo}
                        </Link>}
                        <Link className="btn-primary" to={ROUTE_CLUBS} title="Vis alle foreninger">
                            Foreninger
                        </Link>
                        {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <Link className="btn-primary" to={ROUTE_MEMBERS} title="Vis alle medlemmer">
                            Medlemmer
                        </Link> : null}
                    </span>
                ] : [
                    <span className="left-buttons" key="left">
                        <button className="btn-primary" title="Gem ændringer" onClick = {() => {
                            this.subForm.getWrappedInstance().save((clubNo, memberNo) => {
                                NotificationManager.success(this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? (this.props.params.memberNo.toLowerCase() === 'new' ? "Medlemmet er oprettet" : "Medlemmet er opdateret.") : (this.props.params.memberNo.toLowerCase() === 'new' ? "Nyt medlem" : "Ændringer") + " er lagt til godkendelse.", this.props.params.memberNo.toLowerCase() === 'new' ? "Oprettelse" : "Opdatering", 4000);
                                const memberNo1 = this.props.params.memberNo.toLowerCase().startsWith('new') ? this.props.params.memberNo.substring(3) : this.props.params.memberNo;
                                const memberNo2 = memberNo.toLowerCase().startsWith('new') ? memberNo.substring(3) : memberNo;
                                const memberUrl = this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? memberNo2 : (this.props.params.memberNo.toLowerCase().startsWith('new') ? (memberNo.toLowerCase().startsWith('new') ? memberNo : 'new' + memberNo) : memberNo1);
                                this.props.dispatch(replace(ROUTE_MEMBER.replace(":clubNo", clubNo).replace(':memberNo', memberUrl).replace(':subpage', this.props.params.subpage).replace(':mode', 'view')));
                            })
                        }}>Gem</button>
                    </span>,
                    <span className="right-buttons" key="right">
                        <button className="btn-secondary" title="Annuller ændringer" onClick = {() => {
                            if (memberNo === '') {
                                if (clubNo === 'undefined' || clubNo === 'new') this.props.dispatch(replace(ROUTE_MEMBERS));
                                else this.props.dispatch(replace(ROUTE_CLUB.replace(':clubNo', clubNo).replace(':subpage', 'members').replace(':mode', 'view')));
                            }
                            else this.props.dispatch(replace(ROUTE_MEMBER.replace(":clubNo", clubNo).replace(':memberNo', this.props.params.memberNo).replace(':subpage', this.props.params.subpage).replace(':mode', 'view')));
                        }}>Annuller</button>
                    </span>,
                ]}
            </div>
        </div>);
    }
}

const mapStateToProps = (state) => ({
    auth: {
        isMainAdmin: state.auth.isMainAdmin,
        isSectionAdmin: state.auth.isSectionAdmin,
        isClubAdmin: state.auth.isClubAdmin,
        clubNumber: state.auth.clubNumber,
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        clubs: state.admin.clubs,
        members: state.admin.members,
        pigeonHoles: state.admin.pigeonHoles,
    }
});

export default connect(mapStateToProps)(MemberPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/club/MemberPage.js